// extracted by mini-css-extract-plugin
export default {"avatarImg":"ChatHeader_avatarImg__R0RLa","header":"ChatHeader_header__B-JWM","backBtn":"ChatHeader_backBtn__n+4CQ"};